module.exports = {"id":"209840","name":"Julian Jeanvier","rating":"73","photo":"./data/images/photos/2/209840.png","club":{"name":"Stade de Reims","logo":"./data/images/clubs/StadedeReims.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JulianJeanvier0.json
// module id = 2238
// module chunks = 0